class Slider {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const swiper = new Swiper('.mv-swiper', {
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      effect: 'fade',
      speed: 1000,
      autoplay: {
        delay: 5000,  
      },
    })
  }
}
